import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user'])
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/components/info/resources/computed.js